<template>
  <MenuWrapper class="mx-2 mt-8">
    <template v-for="(route, index) in menuItems" :key="index">
      <MenuLink
        v-if="canView(route)"
        :href="getHref(route?.meta?.href)"
        :newTab="route.meta?.newTab"
        :icon="route.meta?.icon"
        :to="!route.meta?.href && route.name ? { name: route.name } : undefined"
        :title="route.meta?.title || route.name"
        :hoverableTitle="!props.isExpanded"
        :dot-type="route.meta?.badge"
      >
        <span>{{ route.meta?.title }}</span>
        <span v-if="isExpanded && route.meta?.badge" :class="`sidebar-nav-tag sidebar-nav-tag--${route.meta.badge}`">
          {{ route.meta.badge === 'new' ? 'New' : 'Beta' }}
        </span>
      </MenuLink>
    </template>
  </MenuWrapper>
</template>
<script setup lang="ts">
import { MenuWrapper, MenuLink } from '@/storybook/menu';
import { useRouter, RouteRecordRaw } from 'vue-router';
import { SIDEBAR_TYPES } from '@/router';

interface RouteMeta {
  href?: string;
  icon?: string;
  title?: string;
  newTab?: boolean;
  badge?: string;
  visible?: boolean | (() => boolean);
}

type CustomRoute = RouteRecordRaw & {
  name: string;
  meta?: RouteMeta;
};

const props = defineProps<{
  isExpanded: boolean;
  type: SIDEBAR_TYPES;
}>();

const routes = useRouter().getRoutes();
const menuItems = routes.find(c => c.name === props.type)?.children as CustomRoute[] | undefined;

const canView = (route: CustomRoute) => {
  if (route.meta?.visible === false) {
    return false;
  }

  if (typeof route.meta?.visible === 'function') {
    return route.meta.visible();
  }

  return true;
};

const getHref = (href: string | (() => string) | undefined): string => {
  if (!href) {
    return '';
  }

  if (typeof href === 'function') {
    return href();
  }

  return href?.trim();
};
</script>

<style scoped>
.sidebar-nav-tag {
  margin-left: auto;
  padding: 2.5px 8px;
  border: 1px solid;
  border-radius: 999px;
  background: transparent;
  box-shadow: none;
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  line-height: 1;
  text-transform: uppercase;
}

.sidebar-nav-tag--new {
  border-color: rgba(0, 122, 255, 0.45);
  color: var(--blue-600);
}

.sidebar-nav-tag--beta {
  border-color: var(--slate-300);
  color: var(--slate-600);
}
</style>
